module.exports = __webpack_public_path__ + "img/tarj1-2.7a643974.png";